import React from 'react';

function Help() {
  return (
    <div className="py-20 px-6 bg-background min-h-screen">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-black text-primary mb-6">Help Center</h1>
          <p className="text-xl text-slate-600">Get answers to common questions and learn how to use Scope Order.</p>
        </div>

        <div className="space-y-8">
          <section className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
            <h2 className="text-2xl font-bold text-primary mb-6">Getting Started</h2>

            <div className="space-y-6">
              <div>
                <h3 className="font-bold text-lg mb-2">How do I create my first change order?</h3>
                <p className="text-slate-600 mb-3">Creating a change order is simple:</p>
                <ol className="list-decimal list-inside space-y-2 text-slate-600 ml-4">
                  <li>Open the app and tap "New Order"</li>
                  <li>Select or create a client and job</li>
                  <li>Add line items for labor and materials</li>
                  <li>Have your client sign on the device</li>
                  <li>Send the PDF to their email</li>
                </ol>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-2">How do I capture a signature?</h3>
                <p className="text-slate-600">After adding your line items, tap "Get Signature". Your client can sign directly on your device screen using their finger. The signature is saved as part of the change order.</p>
              </div>
            </div>
          </section>

          <section className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
            <h2 className="text-2xl font-bold text-primary mb-6">Managing Clients & Jobs</h2>

            <div className="space-y-6">
              <div>
                <h3 className="font-bold text-lg mb-2">How do I add a new client?</h3>
                <p className="text-slate-600">Go to the Clients screen and tap "Add Client". Enter the client's name and email address. Both are required for sending PDFs.</p>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-2">Can I add multiple jobs for one client?</h3>
                <p className="text-slate-600">Yes! Each client can have unlimited jobs. When creating a change order, you'll select both the client and the specific job.</p>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-2">How do I export my data?</h3>
                <p className="text-slate-600">Go to Settings and tap "Export Data to CSV". This will download all your clients, jobs, and change orders in CSV format.</p>
              </div>
            </div>
          </section>

          <section className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
            <h2 className="text-2xl font-bold text-primary mb-6">Billing & Subscription</h2>

            <div className="space-y-6">
              <div>
                <h3 className="font-bold text-lg mb-2">How much does Scope Order cost?</h3>
                <p className="text-slate-600">Scope Order Pro is $19/month with unlimited change orders, clients, and jobs. Start with a free trial—no credit card required.</p>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-2">Can I cancel my subscription?</h3>
                <p className="text-slate-600">Yes, you can cancel anytime from the Settings screen. There are no cancellation fees or penalties.</p>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-2">What happens to my data if I cancel?</h3>
                <p className="text-slate-600">Your data remains accessible. We recommend exporting to CSV before canceling for your records.</p>
              </div>
            </div>
          </section>

          <section className="bg-white p-8 rounded-2xl shadow-sm border border-slate-200">
            <h2 className="text-2xl font-bold text-primary mb-6">Technical Support</h2>

            <div className="space-y-6">
              <div>
                <h3 className="font-bold text-lg mb-2">The app won't send emails. What should I check?</h3>
                <p className="text-slate-600 mb-3">Make sure:</p>
                <ul className="list-disc list-inside space-y-2 text-slate-600 ml-4">
                  <li>Your device has an internet connection</li>
                  <li>The client email address is correct</li>
                  <li>You've granted email permissions to the app</li>
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-2">Can I use this offline?</h3>
                <p className="text-slate-600">You can create change orders and capture signatures offline. You'll need an internet connection to send PDFs via email.</p>
              </div>
            </div>
          </section>

          <section className="bg-primary text-white p-10 rounded-2xl text-center">
            <i className="fas fa-life-ring text-4xl text-secondary mb-4"></i>
            <h2 className="text-2xl font-bold mb-4">Still Need Help?</h2>
            <p className="text-white/80 mb-6">Can't find what you're looking for? Our support team is here to help.</p>
            <a href="mailto:support@scopeorder.com" className="inline-block bg-secondary text-white px-8 py-4 rounded-xl font-bold hover:bg-orange-600 transition">
              Contact Support
            </a>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Help;
